// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"f97be96b","375":"9b783829","707":"ad1ed8ac","828":"40949c32"}[chunkId] + ".chunk.css";
};